<template>
<div class="chapter">
<div class="inner_page">
<h1>I Cannot Get You Close Enough</h1>
<h3 class="sigil_not_in_toc">Ellen Gilchrist</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0ff2425b